import { ClockCircleOutlined } from '@ant-design/icons'
import { Button, Divider, List, Modal } from 'antd'
import React from 'react'

import isDefined from '../../helpers/isDefined'

type StartModalProps = {
  round: number
  flightNumber: number
  startTime?: string
  playerNames: string[]
  hide(): void
}

const renderPlayerName = (playerName) => <List.Item>{playerName}</List.Item>

const StartModal: React.FunctionComponent<StartModalProps> = ({
  round,
  flightNumber,
  startTime,
  playerNames,
  hide,
}) => (
  <Modal
    className="MobileResults-StartModal"
    visible
    title={`Round ${round} - Flight ${flightNumber}`}
    onCancel={hide}
    footer={
      <Button key="close" onClick={hide}>
        Start
      </Button>
    }>
    {startTime && (
      <React.Fragment>
        <ClockCircleOutlined /> {startTime}
        <Divider />
      </React.Fragment>
    )}
    <List dataSource={playerNames.filter(isDefined)} renderItem={renderPlayerName} />
  </Modal>
)

export default StartModal



// WEBPACK FOOTER //
// ./src/components/mobile/StartModal.tsx